import React from "react";
import styled from "styled-components";
import LayoutContainer from "./Container";
import { Button, Nav } from "rsuite";
import { Link } from "react-router-dom";
import { useCongress } from "../../congress/hooks";
import MenuItem from "./MenuItem";
import Icon from "../Icon";

export default function Menu() {
  const { congress, generateLink } = useCongress();
  console.log(congress)
  return (
    <StyledLayoutContainer>
      <Container>
        <Nav>
          <MenuItem to={generateLink("/information")}>
            <Icon icon="forum" size={30} />
            Información
          </MenuItem>
          <MenuItem to={generateLink("/program")}>
            <Icon icon="activities" size={30} />
            Programa
          </MenuItem>
          <MenuItem to={generateLink("/speakers")}>
            <Icon icon="speakers" size={30} />
            Panelistas
          </MenuItem>
          <MenuItem to={generateLink("/sponsors")}>
            <Icon icon="sponsors" size={30} />
            Sponsors
          </MenuItem>
          {congress.IsActive ? (
            <MenuItem to={generateLink("/stands")}>
              <Icon icon="venue" size={30} />
              Stands
            </MenuItem>
          ) : null}
          {/*TODO: Create dynamic contact form (Like the app)*/}

          <MenuItem to={generateLink("/contact")}>
            <Icon icon="contact" size={30} />
            Contacto
          </MenuItem>
        </Nav>
      </Container>
    </StyledLayoutContainer>
  );
}

const StyledLayoutContainer = styled(LayoutContainer)`
  position: sticky;
  top: 5.5rem;
  z-index: 500;
`;

const Container = styled.div`
  background: #fff;
  box-shadow: 0 4px 15px rgba(102, 102, 102, 0.25);
  border-radius: 15px;
  padding: 2.1rem 0;
  transform: translateY(-50%);
  overflow: auto;
`;
